/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneRadioButton as ResolvedStandaloneRadioButton } from 'base/components/standalone/RadioButton';

export const RadioButton: typeof ResolvedStandaloneRadioButton = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneRadioButton {...props} />
        </ErrorBoundary>
    );
});

export type RadioButtonProps = PropsFromComponent<typeof RadioButton>;

/** @deprecated Use slot architecture instead */
export const RadioButtonWith = (extras: DynamicStandaloneExtras): typeof RadioButton => {
    return function RadioButton(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'RadioButton');
        return <ResolvedStandaloneRadioButton {...mergeProps({ options: { theme } }, props)} />;
    }
}